import { arrayOf, oneOf } from 'prop-types';
import { GIG_FEATURE_BADGE_TYPES } from '../../GigCardListings/utils/gigBadges/constants';

export const excludedBadgesType = arrayOf(oneOf(Object.values(GIG_FEATURE_BADGE_TYPES)));
